/* RESPONSIBLE TEAM: team-proactive-support */
import { helper as buildHelper } from '@ember/component/helper';
import intercomMessengerColors from '@intercom/intercom-messenger-colors';

type ThemeMode = 'light' | 'dark';

function validateColorName(color: unknown): boolean {
  if (!color) {
    return false;
  }
  let style = new Option().style;
  style.color = color as string;

  return !!style.color;
}

export function isBackgroundDark(backgroundColor: unknown): boolean {
  if (!backgroundColor || !validateColorName(backgroundColor)) {
    return false;
  }
  let messengerColors = intercomMessengerColors({
    primaryColor: backgroundColor as string,
  });
  return messengerColors?.primary_type === 'dark';
}

interface MessengerColorsOptions {
  primaryColor: string;
  secondaryColor?: string;
  darkenAmount?: number;
  themeMode?: ThemeMode;
  contrastCheckMethod?: 'contrast-ratio-4.5' | 'contrast-ratio-3.0' | 'luminance';
}

export function calculateContrastTextColor(
  backgroundColor: unknown,
  themeMode: ThemeMode = 'light',
): string | undefined {
  if (!backgroundColor || !validateColorName(backgroundColor)) {
    return undefined;
  }

  // Dark mode uses stricter WCAG AA contrast checking (4.5 ratio)
  // Light mode uses luminance-based checking
  let contrastCheckMethod = themeMode === 'dark' ? ('contrast-ratio-4.5' as const) : undefined;

  let options: MessengerColorsOptions = {
    primaryColor: backgroundColor as string,
    themeMode,
    contrastCheckMethod,
  };

  let messengerColors = intercomMessengerColors(
    options as Parameters<typeof intercomMessengerColors>[0],
  );

  return messengerColors?.header_title_color;
}

export default buildHelper(function ([backgroundColor, themeMode]: [unknown, ThemeMode?]) {
  return calculateContrastTextColor(backgroundColor, themeMode ?? 'light');
});
